/**
 * Wrapper attorno ad `applyPricing` che gestisce automaticamente il
 * mark-up override per riga (vedi computeRowMarkupSubtotal).
 *
 * Da usare in tutti i punti che hanno accesso alle righe del preventivo
 * (vista vendita, sticky summary, dashboard, export PDF).
 */
import type { OrgSettings } from '@/hooks/useOrgSettings';
import { applyPricing, type CostBase, type SellingBreakdown } from './applyPricing';
import { computeRowMarkupSubtotal } from './computeRowMarkupSubtotal';

interface RowLike {
  totalCost?: number | null;
  total_cost?: number | null;
  markupPct?: number | null;
}

function rowTotalCost(r: RowLike): number {
  const n = Number(r.totalCost ?? r.total_cost ?? 0);
  return Number.isFinite(n) ? n : 0;
}

export function applyPricingForRows(
  base: CostBase,
  settings: OrgSettings | null | undefined,
  rows: RowLike[],
  customerDiscountOverride?: number,
): SellingBreakdown {
  const override = computeRowMarkupSubtotal(
    rows.map((r) => ({ totalCost: rowTotalCost(r), markupPct: r.markupPct ?? null })),
    settings,
  );
  return applyPricing(base, settings, customerDiscountOverride, override);
}
